//@import dependencies
import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { GiTeacher } from 'react-icons/gi'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import { IoIosGitNetwork, IoMdBusiness } from 'react-icons/io'
import { BiGroup } from 'react-icons/bi'
import { FaChalkboardTeacher } from 'react-icons/fa'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../listLandingsScreen.scss'
import { MdScreenSearchDesktop } from 'react-icons/md'
import { CiBookmark } from 'react-icons/ci'

// @ADD Component types
interface IListLandingsScreenLayoutProps {
  permission: any
}

const ListLandingsScreenLayout: React.FC<IListLandingsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  const [landings, setLandings] = useState<Array<{title: string, description: string, link: string, icon: any}>>([])

  useEffect(() => {
    let landingsAux = [...landings]
    if (props.permission.checkSimple('permission:landings_teacher')) {
      landingsAux.push({
        title: 'Docentes',
        description: 'Aca podras actualizar la información de la sección publica de docentes',
        link: '/admin/landings/teacher',
        icon: <GiTeacher size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_business')) {
      landingsAux.push({
        title: 'Empresas',
        description: 'Aca podras actualizar la información de la sección publica de empresas',
        link: '/admin/landings/business',
        icon: <IoMdBusiness size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_business')) {
      landingsAux.push({
        title: 'Colaboradores',
        description: 'Aca podras actualizar la información de la sección publica de colaboradores',
        link: '/admin/landings/officials',
        icon: <BiGroup size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_student')) {
      landingsAux.push({
        title: 'Estudiantes',
        description: 'Aca podras actualizar la información de la sección publica de estudiantes',
        link: '/admin/landings/students',
        icon: <FaChalkboardTeacher size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_alliances')) {
      landingsAux.push({
        title: 'Alianzas',
        description: 'Aca podras actualizar la información de la sección publica de alianzas',
        link: '/admin/landings/alliances',
        icon: <IoIosGitNetwork size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_tutorials')) {
      landingsAux.push({
        title: 'Tutoriales',
        description: 'Aca podras actualizar la información de la sección publica de tutoriales',
        link: '/admin/landings/tutorials',
        icon: <MdScreenSearchDesktop size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_home')) {
      landingsAux.push({
        title: 'Home',
        description: 'Aca podras actualizar la información de la landing principal',
        link: '/admin/landings/home',
        icon: <MdScreenSearchDesktop size="3rem" />
      })
    }
    if (props.permission.checkSimple('permission:landings_terms_and_conditions')) {
      landingsAux.push({
        title: 'Terminos y condiciones de pago',
        description: 'Aca podras actualizar la información de terminos y condiciones de pago',
        link: '/admin/landings/terms-and-conditions',
        icon: <CiBookmark size="3rem"/>
      })
    }
    setLandings(landingsAux)
  }, [])

  return(
    <AppContainer>
      <div className='list_landings-screen'>
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.landings')}`]} />

        <div className="row">
          <div className="col-12">
            <h2>Configuración de secciones publicas</h2>
            <hr />
          </div>
        </div>

        <div className='list-landings-container'>
          {landings.length > 0 ? (
            <>
              {landings.map((landing) => (
                <div className="landing-item">
                  <Link to={routingService.getSecurePath(landing.link)}>
                    <div className="landing-index">
                      {landing.icon}
                    </div>
                    <div className="landing-content">
                      <div>
                        <b>{landing.title}</b>
                      </div>
                      <div>
                        {landing.description}
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </>
          ) : (
            <div className="col-12">
              <AlertComponent
                type='warning'
                title={t('screens.list_landings.no_data')}
              />
            </div>
          )}
        </div>
      </div>
    </AppContainer>
  )
}

export default ListLandingsScreenLayout
